<script>
import {
  resourceExpireRemind,
  describeResourceExpireRemind,
} from '@/api/distributor-api'
export default {
  name: 'SettingAlarm',
  data() {
    return {
      isOpen: 0,
      showDialog: false,
      loading: false,
    }
  },
  methods: {
    open() {
      this.showDialog = true
      this.getCurrentStatus()
    },
    close() {
      this.showDialog = false
      this.isOpen = 0
    },
    async confirm() {
      try {
        this.loading = true
        await resourceExpireRemind({ params: { isOpen: this.isOpen } })
        this.$message.success('操作成功')
        this.close()
      } catch (err) {
        console.log(err)
      } finally {
        this.loading = false
      }
    },
    // 查询设置状态
    async getCurrentStatus() {
      try {
        const { result } = await describeResourceExpireRemind({})
        this.isOpen = result.isOpen ? 1 : 0
      } catch (err) {
        console.log(err)
      }
    },
    openLink() {
      window.open(
        'http://message-console.jdcloud.com/message/message-settings',
        '_blank',
      )
    },
  },
}
</script>

<template>
  <el-dialog title="资源到期提醒" :visible.sync="showDialog">
    <div>
      <el-alert type="info" show-icon :closable="false">
        <div slot="title">
          <p>
            1.默认提醒接收人为账号联系人，如需修改可前<span
              @click="openLink"
              class="jc-color-primary mx-4px cursor-pointer"
              >往消息中心</span
            >进行设置
          </p>
          <p>
            2.开启到期提醒后，对于包年包月的资源，您将分别在资源到期前30天、15天、7天、3天、1天收到资源到期提醒。
          </p>
        </div>
      </el-alert>
      <div class="mt-16px">
        <span class="mr-8px">资源到期提醒:</span>
        <el-switch v-model="isOpen" :active-value="1" :inactive-value="0" />
      </div>
    </div>
    <div slot="footer">
      <el-button @click="close">取消</el-button>
      <el-button type="primary" @click="confirm" :loading="loading"
        >确定</el-button
      >
    </div>
  </el-dialog>
</template>
